import { render, staticRenderFns } from "./pie.vue?vue&type=template&id=0fe87510&scoped=true"
import script from "./pie.vue?vue&type=script&lang=js"
export * from "./pie.vue?vue&type=script&lang=js"
import style0 from "./pie.vue?vue&type=style&index=0&id=0fe87510&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe87510",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fe87510')) {
      api.createRecord('0fe87510', component.options)
    } else {
      api.reload('0fe87510', component.options)
    }
    module.hot.accept("./pie.vue?vue&type=template&id=0fe87510&scoped=true", function () {
      api.rerender('0fe87510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bigScreen/components/pie.vue"
export default component.exports